<template>
  <div>
    <topsearch title="Chat" />
    <body class="flex  text-gray-700" style="height: calc(100vh - 100px);">
      <div class="flex flex-col flex-shrink-0 w-64 border-r border-gray-200">
        <div class="h-0 overflow-auto flex-grow">
          <div class="mt-4">
            <div class="flex items-center h-8 px-3 group">
              <button
                id="channels_toggle"
                class="flex items-center flex-grow focus:outline-none"
              >
                <svg
                  class="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="ml-2 leading-none font-medium text-sm"
                  >Kanallar</span
                >
              </button>
              <button
                class="items-center justify-center h-6 w-6 ml-auto rounded hidden group-hover:flex hover:bg-gray-100"
              >
                <svg
                  class="h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                  />
                </svg>
              </button>
              <button
                class="flex items-center justify-center h-6 w-6 ml-1 rounded hover:bg-gray-100"
              >
                <VDropdown :shown="isOpenVDropdown">
                  <!-- This will be the popover reference (for the events and position) -->
                  <button>
                    <svg
                      class="h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                  </button>
 
                  <template #popper>
                    <p>
                      <InlineAddForm
                        table="channels"
                        fieldName="name"
                        showType="modal"
                        keyName="id"
                        type="insert"
                        :inputs="[
                          {
                            name: 'name',
                            label: 'İsim',
                          },
                        ]"
                        header="Yeni Kanal"
                        @after="getChannels()"
                      />
                    </p>
                  </template>
                </VDropdown>
              </button>
            </div>
            <div v-if="channels" id="channels_list">
              <span
                v-for="ch in channels"
                :key="ch.id"
                class="flex items-center cursor-pointer text-black  h-8 hover:bg-gray-100 text-sm pl-8 pr-3"
                @click="channelSet(ch)"
              >
                <svg
                  class="h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M9.243 3.03a1 1 0 01.727 1.213L9.53 6h2.94l.56-2.243a1 1 0 111.94.486L14.53 6H17a1 1 0 110 2h-2.97l-1 4H15a1 1 0 110 2h-2.47l-.56 2.242a1 1 0 11-1.94-.485L10.47 14H7.53l-.56 2.242a1 1 0 11-1.94-.485L5.47 14H3a1 1 0 110-2h2.97l1-4H5a1 1 0 110-2h2.47l.56-2.243a1 1 0 011.213-.727zM9.03 8l-1 4h2.938l1-4H9.031z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="ml-2 leading-none font-bold">{{ ch.name }}</span>
              </span>
            </div>
          </div>
          <div class="mt-4">
            <div class="flex items-center h-8 px-3 group">
              <button
                id="messages_toggle"
                class="flex items-center flex-grow focus:outline-none"
              >
                <svg
                  class="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="ml-2 leading-none font-medium text-sm"
                  >Özel Mesajlar</span
                >
              </button>
              <button
                class="items-center justify-center h-6 w-6 ml-auto rounded hidden group-hover:flex hover:bg-gray-100"
              >
                <svg
                  class="h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                  />
                </svg>
              </button>
              <button
                class="flex items-center justify-center h-6 w-6 ml-1 rounded hover:bg-gray-100"
              >
                <svg
                  class="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
              </button>
            </div>
            <div id="messages_list">
              <a
                class="flex items-center text-black   h-8 hover:bg-gray-100 text-sm pl-8 pr-3"
                href="#"
              >
                <div class="flex justify-center w-4">
                  <span class="w-2 h-2 rounded-full bg-tile-500"></span>
                </div>
                <span class="ml-2 leading-none font-bold">Frodo Baggins</span>
                <span
                  class="flex items-center justify-center bg-tile-500 rounded-full font-medium h-5 px-2 ml-auto text-xs text-white"
                  >3</span
                >
              </a>
              <a
                class="flex items-center text-black  h-8 hover:bg-gray-100 text-sm pl-8 pr-3"
                href="#"
              >
                <div class="flex justify-center w-4">
                  <span class="w-2 h-2 rounded-full bg-tile-500"></span>
                </div>
                <span class="ml-2 leading-none">Gandalf The Grey</span>
              </a>
              <a
                class="flex items-center text-black  h-8 hover:bg-gray-100 text-sm pl-8 pr-3"
                href="#"
              >
                <div class="flex justify-center w-4">
                  <span
                    class="w-2 h-2 rounded-full border-2 border-gray-500"
                  ></span>
                </div>
                <span class="ml-2 leading-none text-gray-500"
                  >Gimli son of Gloin</span
                >
              </a>
              <a
                class="flex items-center text-black  h-8 hover:bg-gray-100 text-sm pl-8 pr-3"
                href="#"
              >
                <div
                  class="flex justify-center items-center rounded bg-gray-600 w-4 h-4"
                >
                  <span class="text-xs text-white">2</span>
                </div>
                <span class="ml-2 leading-none font-bold">Pippin, Merry</span>
                <span
                  class="flex items-center justify-center bg-tile-500 rounded-full font-medium h-5 px-2 ml-auto text-xs text-white"
                  >1</span
                >
              </a>
              <a
                class="flex items-center text-black  h-8 hover:bg-gray-100 text-sm pl-8 pr-3"
                href="#"
              >
                <div
                  class="flex justify-center items-center rounded bg-gray-600 w-4 h-4"
                >
                  <span class="text-xs text-white">3</span>
                </div>
                <span class="ml-2 leading-none">Galadriel, Elrond, Arwen</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="channel" class="flex flex-col flex-grow">
        <div
          class="flex items-center flex-shrink-0 bg-white border-b border-gray-200 p-4"
        >
          <div class="">
            <span class="text-sm font-bold leading-none"
              >#{{ channel.name }}</span
            >
          </div>
        </div>

        <LeadChatMessagesVue :key="channel.id" :channel="channel" />

        <div class="h-12 bg-white px-4 pb-4">
          <form v-if="channel.id" @submit.prevent="sendMessage()">
            <div
              class="flex items-center border-2 border-gray-200 rounded-sm p-1"
            >
              <button
                class="flex-shrink flex items-center justify-center h-6 w-6 rounded hover:bg-gray-200"
              >
                <svg
                  class="h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </button>
              <input
                class="flex-grow text-sm px-3 border-l border-gray-200 ml-1"
                v-model="form.body"
                placeholder="Mesajınız.."
              />
              <button
                class="flex-shrink flex items-center justify-center h-6 w-6 rounded hover:bg-gray-200"
              >
                <svg
                  class="h-4 w-4 transform rotate-90"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"
                  />
                </svg>
              </button>
            </div>
          </form>
        </div>
      </div>
      <!-- Component End  -->
    </body>
  </div>
</template>

<script>
import LeadChatMessagesVue from "../components/LeadChatMessages.vue";
import InlineAddForm from "../components/Ui/InlineAddForm";
import http from "../services/http";

export default {
  name: "list",
  components: { LeadChatMessagesVue, InlineAddForm },
  mounted() {
    this.getChannels();
  },
  methods: {
    channelSet(ch) {
      this.channel = ch;
      this.form.channel_id = ch.id;
      this.form.note_status_id = 7;
      this.$router.push("/chat/ch/" + ch.id, () => {});
    },
    sendMessage() {
      this.form.channel_id = this.channel.id;
      this.form.note_status_id = 7;
      console.log(this.form, "form");
      http
        .inlineSave({
          table: "lead_notes",
          type: "insert",
          inputs: this.form,
        })
        .then((e) => {
          if (e.data.success) {
            this.getChannels();
            this.form.body = "";
            this.form.channel_id = this.channel.id;
            this.form.note_status_id = 7;
          }
        });
    },
    getChannels() {
      this.isOpenVDropdown = false;
      http
        .getData({
          table: "channels",
        })
        .then((resp) => {
          this.channels = resp.data.results;
          this.channel = this.channels.find(
            (e) => e.id == this.$route.params.channel
          );
        });
    },
  },
  data() {
    return {
      form: {},
      isOpenVDropdown: false,
      channel: {},
      channels: [],
    };
  },
};
</script>
